import { Button, Stack } from "@mui/material";
import colors from "assets/scss/colors.scss";

import { useRef, useState, useEffect, useCallback, useMemo } from "react";

//wijmo
import { FlexGrid, FlexGridColumn } from "@grapecity/wijmo.react.grid";
import { Popup } from "@grapecity/wijmo.react.input";
import * as wjcCore from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
import { toggleClass } from "@grapecity/wijmo";
import { Tab, Tabs, Box } from "@mui/material";
import * as wjInput from "@grapecity/wijmo.input";

import "./criteria.css";
import FieldSearchGrid from "./FieldSearchGrid";
import ValueListGrid from "./ValueListGrid";
import useCriteriaParams from "./useCriteriaParams";

function TabPanel(props) {
  const { children, value, type, name, index, ...other } = props;

  useEffect(() => {});

  const gridRefs = useRef([]);

  const valueListGridInit = (flex) => {
    //collapse everything
    flex.hostElement.addEventListener("dblclick", function (e) {
      flex.finishEditing();
    });

    flex.collapseGroupsToLevel(0);

    //hide id
    flex.columns?.forEach((c) => {
      if (c.binding === "id") c.visible = false;
    });

    //custom css for wijmo components
    flex.itemFormatter = (panel, r, c, cell) => {
      toggleClass(cell, "criteria", true);
    };

    //handle cell edit and check all
    flex.formatItem.addHandler((s, e) => {
      // replace collapse button with | + | AND | - |
      var row = s.rows[e.row];
      if (s.cells === e.panel && row instanceof wjcGrid.GroupRow) {
        // remove this class to remove the icons
        var classToRemove =
          "wj-glyph-" + (row.isCollapsed ? "right" : "down-right");
        // change icon according to font awsome icons
        var classToAdd = row?.isCollapsed
          ? "fa-sharp fa-plus boldim"
          : "fa-minus boldim";
        var span = e.cell.querySelector("span." + classToRemove);
        if (span) {
          wjcCore.removeClass(span, classToRemove);
          wjcCore.createElement(`<i class="fa ${classToAdd}"></i>`, span);
        }
      }
    });
  };

  // Make checkboxes editable (Wijmo treegrid makes rows ReadOnly)
  const valueListGridLoadedRows = (flex) => {
    flex.rows.forEach((r) => {
      r.isReadOnly = false;
    });
    flex.columns.forEach((c) => {
      if (c.binding !== "selected") c.isReadOnly = true;
    });
  };

  const fieldSearchGridInit = (flex) => {
    function isRowEditable(row) {
      var item = row.dataItem.operator;
      return item === 10;
    }

    flex.onSelectionChanged = (e) => {
      var row = flex.rows[e.row];
      if (e.col === 2) flex.columns[e.col].isReadOnly = !isRowEditable(row);
    };

    flex.onCellEditEnded = (e) => {
      const grid = e.panel.grid;
      const editingCol = grid.columns[e.col];
      const currentItem = grid.rows[e.row].dataItem;
      const value = currentItem?.operator;
      if (e.col === 0 && currentItem.argument2 && value !== 10) {
        flex.setCellData(e.row, e.col + 2, "");
      }
    };

    const extraRow = new wjcGrid.Row();
    extraRow.allowMerging = true;
    var panel = flex.columnHeaders;

    panel.rows.splice(0, 0, extraRow);
    panel.rows.forEach((r) => {
      if (r?.index === 1) r.visible = false;
    });
    for (let colIndex = 0; colIndex <= 2; colIndex++) {
      panel?.setCellData(0, colIndex, "Αναζήτηση σε Παραστατικά");
    }

    // flex.onSelectionChanging.addHandler((s, e) => {
    //   var row = s.rows[e.row];
    //   console.log(row);
    //   console.log(flex.getCellData(e.r));
    // });

    flex.itemFormatter = (panel, r, c, cell) => {
      toggleClass(cell, "cell-custom", true);
      if (panel === flex.rowHeaders && c === 0) {
        cell.textContent = flex.rows[r].dataItem.fieldName;
      }
      if (c === 2) {
        if (flex.getCellData(r, c - 2) === 10)
          toggleClass(cell, "cell-custom", true);
        else toggleClass(cell, "cell-country", true);
      }
    };

    flex.prepareCellForEdit.addHandler((s, e) => {
      if (e.col === 1) {
        const rootEl = document.createElement("div");
        rootEl.style.width = "100%";
        rootEl.style.height = "100%";
        let control;
        const inputType = s.rows[e.row].dataItem["dataType"];
        const lineId = s.rows[e.row].dataItem["fieldId"];
        switch (inputType) {
          case "bool":
            control = new wjInput.ComboBox(rootEl, {
              itemsSource: ["ΝΑΙ", "ΟΧΙ", "‎"],
            });
            break;
          case "text":
            control = document.createElement("TextArea");
            control.value = s.getCellData(e.row, e.col, false);
            rootEl.appendChild(control);
            break;
          default:
            return;
        }
        if (s.activeEditor) {
          const parentCell = s.activeEditor.parentElement;
          parentCell.style.padding = "0";
          parentCell.insertBefore(rootEl, s.activeEditor);
          control.focus();

          if (!wjcCore.isUndefined(control["text"])) {
            control["text"] = s.activeEditor.value;
          }
        }
        const cellEditEndHandler = (s2, args) => {
          s2.cellEditEnding.removeHandler(cellEditEndHandler);
          if (!args.cancel) {
            args.cancel = true;

            switch (inputType) {
              case "number":
              case "string":
              case "date":
                s2.setCellData(args.row, args.col, control.value, false);
                break;
              case "bool":
                s2.setCellData(args.row, args.col, control.selectedItem, false);
                break;
              default:
            }
            if (control.dispose) {
              control.dispose();
            }
          }
        };
        s.cellEditEnding.addHandler(cellEditEndHandler);
      }
    });

    flex.autoGenerateColumns = false;
  };

  const fieldSearchLoadedRows = (flex) => {
    flex.autoSizeColumns(0, 0, true);
    flex.autoSizeColumns(0, 0);
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{}}>
        {type === "fieldSearch" ? (
          <FieldSearchGrid
            fieldSearchGridInit={fieldSearchGridInit}
            fieldSearchLoadedRows={fieldSearchLoadedRows}
            gridRefs={gridRefs}
            name={name}
          />
        ) : (
          <ValueListGrid
            valueListGridInit={valueListGridInit}
            gridRefs={gridRefs}
            valueListGridLoadedRows={valueListGridLoadedRows}
          />
        )}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

//dummy Data

const Criteria = (props) => {
  const [tab, setTab] = useState(0);

  const { popupInitialized } = props;
  const dataLines1 = useRef([
    {
      id: 0,
      selected: false,
      name: "Κριτήριο23",
      children: [{ id: null, name: "" }],
    },
    { id: 3, selected: false, name: "Κριτήριο2" },
    { id: 4, selected: false, name: "Κριτήριο3" },
    {
      id: 5,
      selected: false,
      name: "Κριτήριο23",
      children: [],
    },
  ]);

  useEffect(() => {}, []);

  return (
    <Popup initialized={popupInitialized}>
      <Stack style={{ maxHeight: "100%", overflowY: "auto" }}>
        <div
          className="wj-dialog-header Qub-DatagridBringValueView"
          style={{ backgroundColor: colors.bringValueHeader }}
        >
          <div>
            <h6 style={{ marginBottom: 0, marginTop: 0 }}>ΚΡΙΤΗΡΙΑ</h6>
          </div>
          <button
            type="button"
            style={{ cursor: "pointer" }}
            tabIndex={-1}
            className="close wj-hide"
          >
            &times;
          </button>
        </div>
        <Stack sx={{ padding: 2 }}>
          <div className={tab === 0 ? "hidden" : ""}>
            <FieldSearchGrid gridRefs={props.gridRefs} name="h1" />
          </div>
          <div className={tab === 1 ? "hidden" : ""}>
            <ValueListGrid
              dataLines1={dataLines1.current}
              gridRefs={props.gridRefs}
              name="h2"
            />
          </div>
          <Button variant="outlined" onClick={() => setTab(0)}>
            ΛΙΣΤΑ ΤΙΜΩΝ
          </Button>
          <Button
            variant="outlined"
            style={{ marginTop: 4 }}
            onClick={() => setTab(1)}
          >
            ΠΕΔΙΑ ΑΝΑΖΗΤΗΣΗΣ
          </Button>
        </Stack>
      </Stack>
    </Popup>
  );
};

export default Criteria;
